/** Wording for the two chat-grant sections, copied from the approved spec 89 mock v3 (2026-10-16). */
export const CHAT_SEGMENTS_TITLE = 'Chat segments';
export const CHAT_SEGMENTS_WHY =
  'Segments this client can chat with, one by one. Past clients have these.';
export const CHAT_SEGMENTS_ADD = 'Add chat segments…';
export const CHAT_SEGMENTS_SUBMIT = 'Grant chat segments';

export const CHAT_AUDIENCES_TITLE = 'Chat audiences';
export const CHAT_AUDIENCES_WHY =
  'Audiences this client can chat with: each opens every chat-ready segment in it. New audiences go here.';
export const CHAT_AUDIENCES_ADD = 'Add chat audiences…';
export const CHAT_AUDIENCES_SUBMIT = 'Grant chat audiences';
export const CHAT_AUDIENCES_HINT =
  'A segment here and under Chat segments is fine: neither removes the other, and the chat list shows it once.';

export const UNREACHABLE_LABEL = 'unreachable';
export const UNREACHABLE_TOOLTIP = 'No segment_chat_config row, so no chat surface can open it';

export const alsoInChatAudienceLabel = (audienceId: number) =>
  `also in chat audience ${audienceId}`;
export const alsoInChatAudienceTooltip = (audienceId: number) =>
  `Also opened by chat audience ${audienceId}. Both grants stay; revoking one leaves the other.`;

export const chatReadyLabel = (count: number) =>
  `${count} chat-ready segment${count === 1 ? '' : 's'}`;
export const CHAT_READY_TOOLTIP = 'Opens chat on its chat-ready segments';
export const NO_CHAT_READY_LABEL = 'no chat-ready segment';
export const NO_CHAT_READY_TOOLTIP =
  'No segment of this audience is registered for chat yet, so nothing opens';
